<template>
  <div class="footer">
    <v-img src="../assets/img/footer-icon.png" class="footer-icon"> </v-img>
    <div class="footer-download">
      <div class="footer-download-text1">
        タイトル<br />ジャンル<br /><span class="price">価格</span><br /><span class="os">対応OS</span>
      </div>
      <div class="footer-download-text2">
        罵りガール〜あやなちゃん〜<br />シミュレーション<br />無料<br />iOS , Android
      </div>
      <a class="footer-ios" href="https://apps.apple.com/app/id1614071391" target="_blank">
        <v-img src="../assets/img/footer-ios.png" />
      </a>
      <a
        class="footer-google"
        href="https://play.google.com/store/apps/details?id=net.cosmojapan.nonoshiri2"
        target="_blank"
      >
        <v-img src="../assets/img/footer-google.png" />
      </a>
    </div>
    <div class="footer-text">
      <p>※端末の性能や仕様、端末固有のアプリ使用状況などにより、正常に動作しない場合があります。</p>
      <p>
        ※Apple および Apple ロゴは米国その他の国で登録された Apple Inc. の商標です。App Store は Apple Inc.
        のサービスマークです。
      </p>
      <p>※Google Play および Google Play ロゴは、Google LLC の商標です。</p>
    </div>
    <div class="footer-privacy">
      <a @click="clickPrivacyPolicy" class="footer-privacy-link">PRIVACY POLICY</a>
      <a @click="clickSitePolicy" class="footer-privacy-link">SITE POLICY</a>
      <a href="https://www.cosmo-japan.net/" target="_blank" class="footer-privacy-copyright">{{
        '©︎ 2022 Cosmo Japan Co., Ltd. All Rights Reserved.'
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterView',
  methods: {
    clickPrivacyPolicy() {
      const routeData = this.$router.resolve('privacy-policy');
      window.open(routeData.href, '_blank');
    },
    clickSitePolicy() {
      const routeData = this.$router.resolve('site-policy');
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  width: 100%;
  background-color: #ff83a3;
  background-image: radial-gradient(#ff7597 30%, transparent 30%), radial-gradient(#ff7597 30%, transparent 30%);
  background-repeat: repeat;
  background-size: 15px 15px;
  background-position: 0 0, 7.5px 7.5px;
  position: absolute;
  color: #ffffff;
  font: 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
  &-icon {
    position: absolute;
    width: 27%;
    top: 12%;
    right: 70%;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
    @media screen and (min-width: 960px) {
      width: 15%;
      top: 23%;
      right: 60%;
    }
  }

  &-download {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 15%;
    padding-left: 32%;
    @media screen and (min-width: 960px) {
      width: 30%;
      margin: 10% auto 0 45%;
      padding: 0;
    }
    &-text1 {
      width: 30%;
      max-width: 200px;
      margin-right: -10%;
      font-size: 3.5vw;
      font-weight: bold;
      letter-spacing: 0.1em;
      white-space: nowrap;
      .price {
        letter-spacing: 2.2em;
      }
      .os {
        letter-spacing: 0.25em;
      }
      @media screen and (min-width: 960px) {
        width: 35%;
        min-width: 100px;
        max-width: 1000px;
        line-height: 2em;
        font-size: 1.5vw;
      }
    }
    &-text2 {
      width: 60%;
      margin: 0 auto 3%;
      font-size: 3.5vw;
      font-weight: bold;
      white-space: nowrap;
      @media screen and (min-width: 960px) {
        width: 65%;
        line-height: 2em;
        font-size: 1.5vw;
      }
    }
  }
  &-ios {
    width: 60%;
    margin: 15% auto 0 -35%;
    @media screen and (min-width: 960px) {
      width: 45%;
      margin: 0 auto;
    }
  }
  &-google {
    width: 60%;
    margin: 15% auto 0 -10%;
    @media screen and (min-width: 960px) {
      width: 45%;
      margin: 0 auto;
    }
  }
  &-text {
    // background:red;
    width: 80%;
    margin: 5% auto 10%;
    font-size: 2.5vw;
    text-align: left;
    @media screen and (min-width: 960px) {
      width: 100%;
      font-size: 1vw;
      font-weight: bold;
      margin: 3% auto 7%;
      text-align: center;
    }
  }
  &-privacy {
    width: 100%;
    margin: 0 auto 2%;
    font-size: 3vw;
    text-align: center;
    @media screen and (min-width: 960px) {
      font-size: 1vw;
    }
    &-link {
      width: 50%;
      margin: 0 10px;
      color: inherit;
      text-decoration: none;
    }
    &-copyright {
      display: block;
      color: inherit;
      text-decoration: none;
    }
  }
}
</style>
